import api from "./api";

export async function getSystemLogSummary() {
    const response = await api.get("/admin/system-logs/summary");
    return response.data;
}

export async function getRequestLogs(filters = {}) {
    const params = new URLSearchParams();

    if (filters.level) params.append("level", filters.level);
    if (filters.statusCode) params.append("statusCode", filters.statusCode);
    if (filters.path) params.append("path", filters.path);
    if (filters.method) params.append("method", filters.method);
    if (filters.take) params.append("take", filters.take);

    const query = params.toString();

    const response = await api.get(
        `/admin/system-logs/requests${query ? `?${query}` : ""}`
    );

    return response.data;
}

export async function getRequestLogDetail(id) {
    const response = await api.get(
        `/admin/system-logs/requests/${id}`
    );

    return response.data;
}